import { render, staticRenderFns } from "./1011.vue?vue&type=template&id=70a5a54c&scoped=true&"
import script from "./1011.vue?vue&type=script&lang=js&"
export * from "./1011.vue?vue&type=script&lang=js&"
import style0 from "./1011.vue?vue&type=style&index=0&id=70a5a54c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a5a54c",
  null
  
)

export default component.exports